import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id D066B111-84BC-4682-864B-CAFEE4A93F66
 * name circle-half-full
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-half-full.svg
 * tags
 * - Shape 
 */
export const CircleHalfFullIcon = createSvgIcon(<><path d="M12 2A10 10 0 0 0 2 12A10 10 0 0 0 12 22A10 10 0 0 0 22 12A10 10 0 0 0 12 2M12 4A8 8 0 0 1 20 12A8 8 0 0 1 12 20V4Z" /></>, 'CircleHalfFullIcon');
export default CircleHalfFullIcon